import { useContext, useState } from 'react'
import { useNavigate, } from 'react-router-dom'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications'
import { IPostCapitalGood } from '../../../../shared/services/capital-good/capital-good.model'
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { GoodForm } from '../../../presentation-components/organisation-components/good/good-form'
import SuperAdminService from '../../../../shared/services/super-admin/super-admin.service'

export const SuperAdminAddNewGoodPage = () => {
  const navigate = useNavigate()
  //Services
  const superAdminService = new SuperAdminService()
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [errorCode, setErrorCode] = useState<number>()
  //Loading State
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false)
  //Variables
  const newGood: IPostCapitalGood = {
    name: '',
    description: '',
    goodCategoryId: '',
    modelNumber: '',
    kgCarbonEmission: undefined,
    manufacturerId: null,
    manufacturerName: '',
    typeOfGood: 'purchasedGood',
    unitType: 'caa84afc-0363-4d70-bd83-7ef33fde5df6',
    unitAmount: 1,
    sourceOfEmission: '',
    // unitMethod: '',
    capitalGoodReference: '',
    capitalGoodImageFilePath: '',
  }
  //Component Event Handlers
  const onSubmit = async (formData: FormData) => {
    if (!isFormSubmitting) {
      setIsFormSubmitting(true)
      superAdminService.createGood(formData)
        .then(response => {
          setIsFormSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' })
          navigate(`/super-admin/products/${response.id}`)
        })
        .catch(err => {
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
          console.log(err)
          setIsFormSubmitting(false)
        })
    } else {
      userNotificationsContext.openSnackbar({ open: true, message: 'Saving in progress, please wait' });
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={'Add New Global Product'}
        includeBackButton={true}
        backButtonLink={`/super-admin/products`}
        backButtonText={`Back to global products`}
      />
      <GoodForm
        newGood={newGood}
        onSubmit={onSubmit}
        isSubmitting={isFormSubmitting}
        errorMessage={errorMessage}
        errorCode={errorCode}
        superAdmin={true}
      />
    </PageOuterContainer >
  )
}